import { useEffect, useState } from "react";
import axios from "axios";
import { endpoints } from "./apiConfig";
import { getAuthHeader, getBusinessName } from "./session";

// The restaurant's current name for the top of the Waiter and Kitchen screens.
// It starts from the name saved in the login session (so there is no flash of
// nothing) and then keeps itself fresh: on load, every minute, and whenever
// the screen comes back into focus — so a rename in Settings appears on staff
// screens without anyone logging in again.
export default function useRestaurantName() {
  const [name, setName] = useState(getBusinessName());

  useEffect(() => {
    let alive = true;
    const load = () => {
      if (!getAuthHeader().Authorization) return;
      axios.get(endpoints.settings, { headers: getAuthHeader() })
        .then((res) => {
          const fresh = res.data.restaurant?.name || res.data.business_name;
          if (alive && fresh) setName(fresh);
        })
        .catch(() => {});
    };
    load();
    const timer = setInterval(load, 60000);
    const onVisible = () => { if (document.visibilityState === "visible") load(); };
    window.addEventListener("focus", load);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      alive = false;
      clearInterval(timer);
      window.removeEventListener("focus", load);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return name;
}
